import {
  IELTFormData,
  ISupportTopic,
  TComplexSectionData,
} from 'legacy/lut/classes/models/partner360/ELT/IELTFormData'
import { useCallback, useMemo } from 'react'

import { Input } from 'core-components/library/inputs'

import { getFormedEltTranslation } from '../../../helpers/getFormedEltTranslation'
import { useTableActions } from '../../../hooks/useTableActions'
import { TOnChangeStringPrimitiveFormData } from '../../../models/TOnChangePrimitiveFormData'
import { Alert } from '../../styledComponents/alert/Alert'
import { TalkingPointsNote } from '../../styledComponents/notes/TalkingPointsNote'
import { StyledInputs } from '../../styledComponents/styledInput/StyledInputs'
import { StyledTable } from '../../styledComponents/styledTable/StyledTable'

import { changeMeetingObjective } from './helpers/changeMeetingObjective'
import { generateCrudWithMemo } from './helpers/generateCrudWithMemo'
import { getSupportTopicColumns } from './helpers/getSupportTopicColumns'

import styles from './SupportTopics.module.scss'

interface IProps {
  formData: IELTFormData
  updateFormData: (data: TComplexSectionData) => void
  onChangePrimitiveFormData: TOnChangeStringPrimitiveFormData
}

const newEmptyRow: ISupportTopic = { TopicArea: '', TalkingPoints: '' }
export const SupportTopics = ({ formData, updateFormData, onChangePrimitiveFormData }: IProps) => {
  const tableData = formData.SupportTopics || []

  const { addRow, canAddNewRow, deleteLastRow, deleteRow, onChange } =
    useTableActions<ISupportTopic>({
      updateFormData: updateFormData,
      data: tableData,
      newEmptyRow,
      canAddNewRowCondFn: (el) => !el.TopicArea && !el.TalkingPoints,
    })

  const getCrud = useMemo(() => generateCrudWithMemo(), [])

  const moveToTop = useCallback(
    (index: number) => {
      const updatedData = [...tableData]
      updatedData.splice(index - 1, 2, updatedData[index], updatedData[index - 1])
      updateFormData(updatedData)
    },
    [tableData]
  )
  const moveToBottom = useCallback(
    (index: number) => {
      const updatedData = [...tableData]
      updatedData.splice(index, 2, updatedData[index + 1], updatedData[index])
      updateFormData(updatedData)
    },
    [tableData]
  )
  const columns = useMemo(
    () =>
      getSupportTopicColumns({
        onChange,
        getCrud,
        moveToTop,
        moveToBottom,
        dataLength: tableData.length,
      }),
    [tableData, moveToTop, moveToBottom]
  )
  return (
    <div>
      <StyledInputs label={getFormedEltTranslation('meeting-objective')} margin={'xl'}>
        <Input
          placeholder={'[RELATIONSHIP]  [CLOSING DEAL]  [WINNING SHARE]'}
          value={formData.MeetingObjective || '' || ''}
          onChange={changeMeetingObjective(onChangePrimitiveFormData)}
        />
      </StyledInputs>
      <div className={styles.table}>
        <StyledTable<ISupportTopic>
          columns={columns}
          items={tableData}
          addRow={addRow}
          deleteLastRow={deleteLastRow}
          deleteRow={deleteRow}
          canAddNewRow={canAddNewRow}
          classes={{ header: styles.header, deleteIcon: styles.deleteIcon }}
        />
      </div>
      <Alert margin={{ top: 'xl' }}>
        <TalkingPointsNote />
      </Alert>
    </div>
  )
}
